import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';

const SimpleHeader = () => {
  return (
    <header className="fixed top-0 left-0 right-0 bg-[#F5F1E8] z-50 border-b border-[#E5DFD0]">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center">
          <h1 className="text-2xl font-bold tracking-tight">
            <span className="text-[#2C1810]">Spend</span>
            <span className="text-[#6B7A5C]">Less</span>
          </h1>
        </Link>
        
        <nav className="hidden md:flex items-center gap-8">
          <Link 
            to="/blog"
            className="text-[#2C1810] hover:text-[#6B7A5C] transition-colors text-sm"
          >
            Blog
          </Link>
          <Link 
            to="/products/community"
            className="text-[#2C1810] hover:text-[#6B7A5C] transition-colors text-sm"
          >
            Community
          </Link>
          <Link 
            to="/access"
            className="text-[#2C1810] hover:text-[#6B7A5C] transition-colors text-sm"
          >
            My Guides
          </Link>
          <Link to="/products/guide">
            <Button 
              className="bg-[#C17855] hover:bg-[#B06745] text-white px-6 py-2 rounded-lg transition-all relative"
            >
              <span className="absolute -top-2 -right-2 bg-[#6B7A5C] text-white text-xs px-2 py-0.5 rounded-full font-bold">
                33% OFF
              </span>
              Get the Guide — $9.99
            </Button>
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default SimpleHeader;